import { mediaQueries } from 'shared/breakpoints';
import styled, { css } from 'styled-components';
import { SectionWrapper, MotherWebsiteText } from 'styles/Typography.styled';

export const StyledSectionWrapper = styled(SectionWrapper)`
    display: flex;
    padding: 160px 20px 0;

    ${mediaQueries.md} {
        align-items: center;
        padding: 56px 16px;
    }
    ${mediaQueries.sm} {
        flex-direction: column;
    }
`;

export const LeftWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1.05;
    padding-right: 100px;

    ${mediaQueries.sm} {
        padding-right: 0;
    }
`;

export const RightWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    gap: 32px;

    ${mediaQueries.lg} {
        flex-direction: column;
    }

    ${mediaQueries.sm} {
        flex-direction: row;
    }

    ${mediaQueries.xs} {
        flex-direction: column;
    }
`;

export const TextDescription = styled(MotherWebsiteText)<{
    removeMarginTop?: boolean;
}>(
    ({ removeMarginTop, theme: { fontWeight, colors } }) =>
        css`
            color: ${colors.neutral300};
            display: flex;
            font-weight: ${fontWeight.medium};
            line-height: 32px;
            margin-top: ${removeMarginTop ? '0' : '24px'};
            max-width: 544px;
            padding-bottom: 40px;

            ${mediaQueries.sm} {
                max-width: 100%;
                padding-bottom: 32px;
            }
        `,
);

export const Image = styled.img`
    flex: 1;
    max-height: 360px;
    max-width: 100%;

    ${mediaQueries.sm} {
        display: none;
    }
`;

export const ImageMobile = styled.img`
    display: none;

    ${mediaQueries.sm} {
        display: block;
        max-height: 360px;
    }
`;

export const ButtonWrapper = styled.div`
    margin-top: 16px;
    max-width: 300px;

    ${mediaQueries.sm} {
        margin: 16px auto 56px auto;
        max-width: unset;
        min-width: 240px;
    }
`;
